import { useState } from "react";
import "./App.css";

function App() {
    const [currentText, setText] = useState("");
    const [translation, setTranslation] = useState("");
    const [isLoading, setLoading] = useState(false);

    function handleChange(inputEl) {
        setText(inputEl.target.value);
    }

    function handleSubmit(submitEvent) {
        submitEvent.preventDefault();
        if (!currentText.trim()) {
            return;
        }
        loadTranslation(currentText);
        setText("");
    }

    async function apiCall(lang1, lang2, text) {
        const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=${lang1}&tl=${lang2}&dt=t&q=${encodeURIComponent(text)}`;
        const res = await fetch(url);
        if (!res.ok) {
            throw new Error(`Translation API returned status ${res.status}`);
        }
        const data = await res.json();
        if (data && data[0]) {
            return data[0].map((segment) => segment[0]).join("");
        }
        throw new Error("Invalid response format from translation service");
    }

    async function loadTranslation(translationText) {
        setLoading(true);
        setTranslation("");
        try {
            const firstTranslation = await apiCall("en", "zh-CN", translationText);
            const secondTranslation = await apiCall("zh-CN", "ja", firstTranslation);
            const thirdTranslation = await apiCall("ja", "pa", secondTranslation);
            const reverted = await apiCall("pa", "en", thirdTranslation);
            setTranslation(reverted);
        } catch (error) {
            console.error("Translation error:", error);
            setTranslation("Translation failed. Please try again.");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="App">
            <h1>GARBLE</h1>
            <form>
                <input
                    type="text"
                    placeholder="Enter your text"
                    onChange={handleChange}
                    value={currentText}
                />
                <button onClick={handleSubmit}>Translate!</button>
            </form>

            <div className="translation">
                <h2>Your text will be translated to Chinese, then Japanese, and then back to English!</h2>
                <p>
                    <span>Garbled</span> text:
                </p>
                <p>{isLoading ? "Loading..." : translation}</p>
            </div>
        </div>
    );
}

export default App;
